import { findIndex, cloneDeep } from "lodash";
const initialState = {
  //predtictedQuestionTableData: null
}

export function PredictedQuestionTableReducer(state, action) {
  switch (action.type) {
    case 'QUESTION_TABLE_CELL_UPDATE':
      return onCellUpdate(state, action.payload);
    case 'QUESTION_TABLE_CELL_UPDATE_RESULTS':
      return onCellUpdateResults(state, action.payload);
    case 'QUESTION_TABLE_SUBMIT':
      return onQuestionSubmit(state, action.payload);
    // case 'QUESTION_TABLE_RESET':
    //   return onColorPredictionReset(state);
    case 'SET_PREDICTED_QUESTION_TABLE_DATA':
      state.protocolSection.predictedQuestionTableData = action.payload.predictedQuestionTableData;
      return state
    default:
      return state;
  }
}

function onUpdateCellData(data, payload) {
  const [rowId, colId] = payload.id.split('_').map((id) => parseInt(id));
  return data.map((row, rowIndex) => {
    if (rowIndex === rowId) {
      return row.map((col, colIndex) => {
        if (colIndex === colId) {
          col = {...col, value: payload.value, showFeedback: false};
        }
        return col;
      });
    }
    return row;
  });
}

function onUpdateCellText(data, payload) {
  const [rowId, colId] = payload.id.split('_').map((id) => parseInt(id));
  return data.map((row, rowIndex) => {
    if (rowIndex === rowId) {
      return row.map((col, colIndex) => {
        if (colIndex === colId) {
          col = {...col, text: payload.value, showFeedback: false};
        }
        if (colIndex === (colId + 1)) {
          col = {...col, answer: payload.answer, showFeedback: false};
        }
        return col;
      });
    }
    return row;
  });
}

function onCellUpdateResults(state, payload) {

  let question = state.levelData.RESULTS.components[findIndex(state.levelData.RESULTS.components, {type: "QUESTION_TABLE"})];
  question.submitDisabled = true;

  if (question.totalAttempts > 0) {
    question.data = onUpdateCellText(question.data, payload);
    question.submitDisabled = false;
  }

  let currentComponents = cloneDeep(state.levelData.RESULTS.components);
  currentComponents[findIndex(state.levelData.RESULTS.components, {type: "QUESTION_TABLE"})] = question;

  let levelData = state.levelData;
  levelData.RESULTS.components = currentComponents;

  return {...state, ...{levelData: levelData}};
}

function onCellUpdate(state, payload) {

  let question = state.currentSection.components[findIndex(state.currentSection.components, {type: "QUESTION_TABLE"})];
  question.submitDisabled = true;

  if (question.totalAttempts > 0) {
    question.data = onUpdateCellData(question.data, payload);
    question.submitDisabled = false;
  }

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "QUESTION_TABLE"})] = question;

  return {...state, ...{currentSection: {
    title: state.currentSection.title,
    components: currentComponents
  }}};

}

function onQuestionSubmit(state, payload) {

  let question = state.currentSection.components[findIndex(state.currentSection.components, {type: "QUESTION_TABLE"})];

  let tableData = setFeedbackOnTableData(question.data);
  let complete = checkIfAllAnswersCorrect(tableData);
  let totalAttempts = question.totalAttempts - 1;
  if (totalAttempts <= 0) complete = true;
  if (complete) {
    tableData = setDisableOnTableData(tableData, true);
  } else {
    tableData = setDisableOnTableData(tableData);
  }
  let submitDisabled = true;

  question.data = tableData
  question.complete = complete
  question.totalAttempts = totalAttempts
  question.submitDisabled = submitDisabled

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "QUESTION_TABLE"})] = question;

  //let titles = question.data[0].map(title => title.text);

  // let data = question.data;
  // data.shift();
  // data = data.map((row)=>{
  //   let obj = {};
  //   titles.map((title, index)=>{
  //       switch(row[index].type) {
  //         case "TITLE":
  //           // code block
  //           obj[title] = row[index].text
  //           break;
  //         case "FIXED":
  //           // code block
  //           obj[title] = row[index].text
  //           break;
  //         case "INPUT":
  //           // code block
  //           obj[title] = row[index].value
  //           break;
  //         default:
  //           obj[title] = row[index].text
  //           // code block
  //       }
  //   })
  //   return obj;
  // })

  return {...state, ...{currentSection: {
    title: state.currentSection.title,
    components: currentComponents
  }}};
}

function checkIfAllAnswersCorrect(tableData) {
  return tableData.reduce((isCorrect, row) => {
    if (isCorrect) {
      row.forEach((cell) => {
        if (isCorrect && cell.hasOwnProperty('answer')) {
          if (typeof cell.answer === 'string') {
            isCorrect = cell.answer.toLowerCase() === cell.value.toLowerCase();
          }
          if (typeof cell.answer === 'number') {
            isCorrect = cell.answer === cell.value;
          }
          if (Array.isArray(cell.answer)) {
            isCorrect = cell.value >= cell.answer[0] && cell.value <= cell.answer[1];
          }
        }
      });
    }
    return isCorrect;
  }, true);
}

function setDisableOnTableData(tableData, override = null) {
  return tableData.map((row) =>
    row.map((cell) => {
      if (cell.hasOwnProperty('answer')) {
        let disabled = false;
        if (override !== null) {
          disabled = override;
        } else {
          if (typeof cell.answer === 'string') {
            if (cell.answer.toLowerCase() === cell.value.toLowerCase()) {
              disabled = true;
            }
          }
          if (typeof cell.answer === 'number') {
            if (cell.answer === cell.value) {
              disabled = true;
            }
          }
          if (Array.isArray(cell.answer)) {
            if(cell.value >= cell.answer[0] && cell.value <= cell.answer[1]){
              disabled = true;
            }
          }
        }
        cell = {...cell, disabled};
      }
      return cell;
    })
  );
}

function setFeedbackOnTableData(tableData) {
  return tableData.map((row) =>
    row.map((cell) => ({...cell, showFeedback: true}))
  );
}

